<script setup lang="ts">
const emit = defineEmits(["update:modelValue"]);
const attrs = useAttrs();
const props = defineProps(["modelValue", "error", "min", "max", "nullable"]);
const inputValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newValue) => {
    inputValue.value = attrs.type === "number" && !props.nullable ? parseFloat(newValue) : newValue;
  },
);
const handleInput = async (event: any) => {
  const value = event.target.value;

  if (attrs.type === "number") {
    if (value === "" && props.nullable) {
      inputValue.value = value;
      emit("update:modelValue", null);
    } else if (!isNaN(parseFloat(value))) {
      let numberValue = parseFloat(value);
      const originalValue = numberValue;

      if (Number.isFinite(props.min) && numberValue < Number(props.min)) {
        numberValue = Number(props.min);
      } else if (Number.isFinite(props.max) && numberValue > Number(props.max)) {
        numberValue = Number(props.max);
      }

      // Si la valeur a été modifiée par les contraintes, forcer la mise à jour de l'input
      if (originalValue !== numberValue) {
        await nextTick();
        event.target.value = numberValue;
      }

      inputValue.value = numberValue;
      emit("update:modelValue", numberValue);
    }
  } else {
    inputValue.value = value;
    emit("update:modelValue", value);
  }
};
</script>
<template>
  <span class="common_input__container body_regular" :data-error="error">
    <input v-bind="$attrs" :value="inputValue" :min="min" :max="max" @input="handleInput" />
  </span>
</template>
<style scoped lang="scss">
@use "assets/scss/texts";
@use "assets/scss/common";

.common_input__container {
  @extend .heading_4_regular;
  @apply flex flex-1 items-center;
  background: var(--grey-light);
  border: 1px solid var(--grey-lightest);
  border-radius: 8px;
  color: var(--text-main-color);
  min-height: 40px;
  /* Adjust border on hover or focus of input */
  &:has(input:not([disabled]):not([readonly]):hover),
  &:has(input:not([disabled]):not([readonly]):focus) {
    border-color: var(--primary-blue-color);
  }

  /* Placeholder styling remains unchanged */
  input {
    @apply text-primary-color w-full text-end px-[16px];
    background: none;
    line-height: 20px;
    height: 100%;

    &::placeholder {
      color: var(--grey-medium);
    }

    &:disabled,
    &:read-only {
      color: var(--text-secondary-color);
      border-color: transparent;
    }
  }

  /* Remove border when input is disabled or readonly */
  &:has(input:disabled),
  &:has(input:read-only) {
    border-color: transparent;
  }

  /* Error styling */
  &[data-error="true"] {
    border: 1px solid var(--red-main);
  }
}
</style>
